/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 10.983,
    height: 17.639,
    viewBox: '0 0 10.983 17.639',
    data: '<g data-name="Group 2171"><g data-name="Group 2170" transform="translate(.5 .5)" _fill="none" _stroke="#262422" stroke-linecap="round" stroke-linejoin="round"><rect pid="0" data-name="Rectangle 2836" width="9.983" height="16.639" rx="2"/><path pid="1" data-name="Line 101" d="M0 12.202h9.983"/></g></g>'
  }
})
